/*
    Overlay GridTeaser

    handle same size ...
*/
(($) => {

    $(document).ready(setMinHeight);
    $(window).on("resize", setMinHeight);

    /**
     * set grid-teaser min-height
     */
    function setMinHeight() {

        let minHeight = $("[data-min-height]");

        if (minHeight) {
            minHeight
            .css('min-height', 'auto')
            .each(function (index, item) {
                let height = $(item).height();
                $(item).css('min-height', height);
            });
        }
    }


})(jQuery);



